
import { defineComponent } from 'vue';

export default defineComponent({
	props: {
		text: String,
		color: String,
		width: String,
		height: String,
		classes: Array,
	},

	setup(props) {
		const bgClassName = `bg-${props.color}`;

		return {
			bgClassName: bgClassName,
		};
	},
});
